import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	currentScenarioLabel: {
		id: 'portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.current-scenario-label',
		defaultMessage: '(current)',
		description: 'Label text for current scenario',
	},
	dialogTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.dialog-title',
		defaultMessage: 'Create scenario',
		description: 'Dialog title',
	},
	dialogTitleFirstScenario: {
		id: 'portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.dialog-title-first-scenario',
		defaultMessage: 'Create first scenario',
		description: 'Dialog title for the first scenario',
	},
	titleLengthValidation: {
		id: 'portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.title-length-validation',
		defaultMessage: 'The scenario title cannot exceed 255 characters.',
		description:
			'Error message displayed below the scenario title field when the scenario title is longer than 255 characters.',
	},
	firstScenarioDescription: {
		id: 'portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.first-scenario-description',
		defaultMessage:
			"Any changes that aren't saved yet will exist in this scenario. You can also create additional scenarios at any time.",
		description: 'Description text for the first scenario dialog window',
	},
	scenarioTitle: {
		id: 'portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.scenario-title',
		defaultMessage: 'Scenario name',
		description: 'Field displayed above the scenario title field.',
	},
	scenarioTitlePlaceholder: {
		id: 'portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.scenario-title-placeholder',
		defaultMessage: 'e.g. Best case',
		description: 'Scenario title field placeholder.',
	},
	scenarioColor: {
		id: 'portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.scenario-color',
		defaultMessage: 'Color',
		description: 'Aria-label displayed on the colour picker field.',
	},
	scenarioCreateFrom: {
		id: 'portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.scenario-create-from',
		defaultMessage: 'Create from',
		description: 'Radio group label.',
	},
	createFromBlank: {
		id: 'portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.create-from-blank',
		defaultMessage: 'Blank scenario',
		description: 'Label for the radio option.',
	},
	createFromScenario: {
		id: 'portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.create-from-scenario',
		defaultMessage: 'Copy of:',
		description: 'Label for the radio option.',
	},
	scenarioTitleEmpty: {
		id: 'portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.scenario-title-empty',
		defaultMessage: 'Please enter a scenario title',
		description: 'Error message displayed below the field when the scenario title is empty.',
	},
	requiredFieldsSummary: {
		id: 'portfolio-3-portfolio.app-simple-plans.settings.scenarios.scenario-dialog.required-fields-summary',
		defaultMessage: 'Required fields are marked with an asterisk',
		description:
			'On the scenario dialog modal, text shown to indicate what the asterisk means next to form field labels.',
	},
});
